module.exports = __webpack_public_path__ + "static/media/avatar43.ffdc84be.png";